import React from "react";
import type { KgArtifactIconProps } from "./KgArtifactIcon.types";

/** Monitor icon for artifact nodes (16px). */
export const KgArtifactIcon: React.FC<KgArtifactIconProps> = ({
  size = 16,
  className,
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    aria-hidden
    className={className}
  >
    <rect
      x="2"
      y="3"
      width="12"
      height="8"
      rx="1"
      stroke="currentColor"
      strokeLinejoin="round"
    />
    <path
      d="M5.33 13.33h5.34"
      stroke="currentColor"
      strokeLinecap="round"
    />
    <path d="M8 11.33v2" stroke="currentColor" strokeLinecap="round" />
  </svg>
);

export default KgArtifactIcon;
